import HttpRequest from "../http_request";

class AuthApi extends HttpRequest {
  apiGetAccountShop(data) {
    return this.fetch(`/client/v1/account-child-link`,data);
  }
  apiGetInitPermission() {
    return this.fetch(`/client/v1/init`);
  }
  apiGetAccessLevel() {
    return this.fetch(`/client/v1/account-access-levels`);
  }
  apiGetcheckKeyInvite(key) {
    return this.fetch(`/client/v1/invite/${key}`);
  }
  apiGetGraphParcelProvince(data) {
    return this.fetch(`/client/v1/dashboards/period-shipment-orders/provinces`, data);
  }
  apiGetGraphWeightSize(data) {
    return this.fetch(`/client/v1/dashboards/period-shipment-orders/volumes`, data);
  }
  apiCreateloginSystem(data) {
    let dataCreate = {
      username: data.email,
      password: data.password
    };
    return this.create(`/client/v1/auth/login`, dataCreate);
  }
  apiCreateselectShop(partnerId) {
    let partner = { parent_id: partnerId };
    return this.create(`/client/v1/account-child-link`, partner);
  }
  apiCreateregister(data) {
    let dataCreate = {
      email: data.email,
      telephone: data.phone
    };
    return this.create(`/client/v1/register/request-otp-for-register`, dataCreate);
  }
  apiCreatereSendOtp(telephone) {
    return this.create(`/client/v1/register/resend-otp`, {
      telephone: telephone
    });
  }
  apiCreateConfirmOtp(data) {
    return this.create(`/client/v1/register/confirm-otp`, data);
  }
  apiCreateforgetSendEmailOTP(phone) {
    return this.create(`/client/v1/auth/forgot-password`, { telephone: phone });
  }
  apiCreateforgetVerifyOtp(data) {
    return this.create(`/client/v1/auth/verify-otp`, data);
  }
  apiCreateconfirmChangePassword(data) {
    return this.create(`/client/v1/auth/forgot-password-confirm`, data);
  }
  apiCreatelotOut() {
    return this.create(`/client/v1/auth/logout`);
  }
  apiCreateuseKeyInvite(key) {
    return this.create(`/client/v1/accounts-childs/verify/${key}`);
  }
  async apiEditsendSupportRequest(statusRequest) {
    let dataEdit = { request_support_flag: statusRequest };
    return this.edit(`/client/v1/accounts/request-support`, dataEdit);
  }
}

export default AuthApi;
